import { FormControlLabel, Switch } from '@mui/material';
import { ParameterProps } from './parameterSelector';
import { ChangeEvent } from 'react';
import i18n from '../../../../locales/i18n';

const BoolParameter = ({ name_de, name_en, selected, onChange }: ParameterProps): JSX.Element => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.checked);
  const currentLanguage = i18n.language;
  return (
    <FormControlLabel
      control={<Switch onChange={handleChange} checked={(selected ?? false) as boolean} />}
      label={currentLanguage === 'de' ? name_de : name_en}
    />
  );
};

export default BoolParameter;
